export const common = {
  nav: {
    home: "首頁",
    wms: {
      title: "WMS倉庫系統",
      ecommerce: "電商物流WMS",
      thirdParty: "第三方物流WMS",
      hkGuide: "香港WMS系統指南",
      selectionGuide: "WMS/TMS選型指南",
    },
    ecommerce_wms: "電商物流WMS",
    logistics_wms: "第三方物流WMS",
    tms: {
      title: "TMS運輸系統",
      fleet: "車隊管理系統",
      address: "智能地址解析",
      selectionGuide: "WMS/TMS選型指南",
    },
    erp: "ERP企業管理系統",
    erpCaseStudies: "案例分享",
    tplsp: "第三方物流資助計劃 (3PL Funding)",
    knowledge: "物流知識庫",
    knowledgeArticles: "物流知識文章",
    insights: "物流新聞解讀",
    about: "關於我們",
    contact: "聯絡我們",
    language: "中",
  },
  hero: {
    title: "香港 WMS、TMS 及 ERP 系統專家",
    subtitle: "專為本地企業打造的智能營運及物流解決方案",
    description:
      "作為香港領先的 WMS、TMS 及 ERP 系統供應商，AUTOCHAIN 協助企業整合倉庫、運輸及企業管理流程，提升效率，降低成本。",
    cta: "立即體驗",
    cta1: "免費獲取方案",
    cta2: "預約演示",
    demo: "預約演示",
  },
  painPoints: {
    title: "您是否正面臨這些物流挑戰？",
    warehouse: {
      title: "倉儲管理痛點",
      pain1: "庫存數據不準確，經常出現缺貨或積壓",
      pain2: "人工作業效率低，容易出錯",
      pain3: "無法實時追蹤貨物位置和狀態",
      pain4: "倉庫空間利用率不高，成本居高不下",
    },
    transport: {
      title: "運輸管理痛點",
      pain1: "無法實時掌握車輛位置和運輸狀態",
      pain2: "路線規劃不合理，增加運輸成本",
      pain3: "司機管理困難，薪酬計算複雜",
    },
    solution: "✅ AUTOCHAIN 智能物流系統為您解決所有痛點！",
  },
  products: {
    title: "我們的解決方案",
    subtitle: "由 WMS、TMS 到 ERP，為企業營運與物流流程提供更完整的系統支持",
    wms: {
      title: "WMS 倉庫管理系統",
      description: "智能化倉庫管理，提升庫存精確度和作業效率",
      benefit: "✅ 提升 40% 倉庫作業效率，庫存準確率達 99.9%",
      cta: "了解 WMS 系統",
    },
    tms: {
      title: "TMS 運輸管理系統",
      description: "優化運輸路線，降低物流成本，提升配送效率",
      benefit: "✅ 節省 30% 運輸成本，提升客戶滿意度",
      cta: "了解 TMS 系統",
    },
    erp: {
      title: "ERP 企業管理系統",
      description: "整合財務、採購、銷售、庫存與客戶資料，讓日常管理更清晰",
      benefit: "✅ 簡單易用、逐步上線，適合由 Excel 過渡的香港企業",
      cta: "了解 ERP 系統",
    },
  },
  integration: {
    title: "WMS + TMS 整合威力",
    effect: "1 + 1 > 2 的協同效應",
    description:
      "當 WMS 和 TMS 系統完美整合時，您的物流業務將實現前所未有的效率提升。從訂單接收到最終配送，每個環節都能無縫銜接，為您創造更大的商業價值。",
    steps: {
      step1: {
        title: "訂單接收",
        desc: "自動接收並分析訂單",
      },
      step2: {
        title: "WMS 處理",
        desc: "智能分配庫存和揀貨",
      },
      step3: {
        title: "TMS 調度",
        desc: "優化路線和車輛安排",
      },
      step4: {
        title: "客戶通知",
        desc: "實時更新配送狀態",
      },
    },
  },
  features: {
    title: "核心功能",
    subtitle: "全方位智能物流管理",
    wms: {
      title: "WMS 倉庫管理系統",
      description: "智能化倉庫管理，提升庫存精確度和作業效率",
    },
    tms: {
      title: "TMS 運輸管理系統",
      description: "優化運輸路線，降低物流成本，提升配送效率",
    },
    ai: {
      title: "AI 智能分析",
      description: "運用人工智能技術，預測需求，優化庫存配置",
    },
  },
  benefits: {
    title: "為什麼選擇 AUTOCHAIN",
    subtitle: "專業的物流技術解決方案",
    efficiency: "提升效率",
    efficiencyDesc: "自動化流程減少人工錯誤，提升 40% 作業效率",
    cost: "降低成本",
    costDesc: "優化庫存管理和運輸路線，節省 30% 營運成本",
    accuracy: "精確管理",
    accuracyDesc: "實時追蹤和數據分析，庫存準確率達 99.9%",
    support: "專業支援",
    supportDesc: "24/7 技術支援，確保系統穩定運行",
  },
  testimonials: {
    title: "客戶見證",
    subtitle: "看看我們的客戶怎麼說",
    customer1: {
      name: "張經理",
      role: "CaseTify 物流總監",
      quote:
        "使用 AUTOCHAIN 的 WMS 系統後，我們的庫存準確率提升到 99.8%，大大減少了缺貨情況。",
    },
    customer2: {
      name: "李總監",
      role: "香港餅家 營運總監",
      quote:
        "TMS 系統幫助我們優化了配送路線，運輸成本降低了 25%，客戶滿意度也大幅提升。",
    },
    customer3: {
      name: "王主管",
      role: "San-Legend Global 倉庫主管",
      quote:
        "整合的 WMS+TMS 解決方案讓我們的物流作業更加順暢，效率提升了 40%。",
    },
  },
  howItWorks: {
    title: "如何開始",
    subtitle: "簡單四步，開啟您的智能物流之旅",
    step1: "需求分析",
    step1Desc: "我們的專家團隊深入了解您的業務需求",
    step2: "方案設計",
    step2Desc: "為您量身定制最適合的物流解決方案",
    step3: "系統部署",
    step3Desc: "快速部署系統，提供全面的培訓支援",
    step4: "持續優化",
    step4Desc: "持續監控和優化，確保最佳效果",
    description: "我們的專業團隊將全程陪伴您，確保系統順利上線並發揮最大效益。",
    cta: "立即開始",
  },
  partners: {
    title: "信賴夥伴",
    subtitle: "眾多知名企業選擇 AUTOCHAIN",
  },
  finalCta: {
    title: "準備開始您的智能物流之旅？",
    description:
      "立即聯絡我們，獲得專業的物流解決方案諮詢，讓您的業務更上一層樓。",
    requirements: "我們只需要以下基本資訊：",
    req1: "聯絡人姓名",
    req2: "聯絡電話",
    req3: "公司名稱",
    contact: "或直接致電：+852 9425 2903",
  },
  contactForm: {
    title: "聯絡我們",
    subtitle: "填寫表單，我們將在 24 小時內與您聯絡",
    name: "姓名",
    namePlaceholder: "請輸入您的姓名",
    company: "公司名稱",
    companyPlaceholder: "請輸入公司名稱",
    email: "電子郵件",
    emailPlaceholder: "請輸入電子郵件",
    phone: "聯絡電話",
    phonePlaceholder: "請輸入聯絡電話",
    message: "需求描述",
    messagePlaceholder: "請描述您的具體需求...",
    submit: "提交諮詢",
    submitSuccess: "提交成功！我們將在 24 小時內與您聯絡。",
    submitError: "提交失敗，請稍後再試或直接致電聯絡我們。",
  },
  cta: {
    title: "準備開始您的智能物流之旅？",
    subtitle: "立即聯絡我們，獲得專業的物流解決方案諮詢",
    button: "免費諮詢",
  },
  footer: {
    company: "AUTOCHAIN TECHNOLOGY",
    description: "專業的智能物流解決方案提供商",
    quickLinks: "快速連結",
    contact: "聯絡資訊",
    address: "香港九龍觀塘區",
    phone: "+852 9425 2903",
    email: "info@autochain.tech",
    copyright: "© 2024 AUTOCHAIN TECHNOLOGY. 保留所有權利。",
  },
  aboutUs: {
    title: "關於 AUTOCHAIN",
    subtitle: "香港本地物流科技專家",
    story: "我們的故事",
    storyContent:
      "AUTOCHAIN 成立於香港，由一群擁有超過 15 年物流行業經驗的專業團隊創立。我們深明香港中小企業在物流管理上面對的挑戰——從倉庫空間有限、人手不足，到運輸成本高昂、客戶要求即日送達等壓力。正因如此，我們決心開發一套真正切合本地市場需要的智能物流系統。",
    mission: "我們的使命",
    missionContent:
      "讓每一間香港企業都能享用企業級的物流管理技術。我們相信，優質的物流系統不應該只是大企業的專利。透過雲端技術和靈活的定價模式，我們讓中小企業也能以合理成本提升物流效率，在競爭激烈的市場中脫穎而出。",
    team: "專業團隊",
    teamContent:
      "我們的團隊成員來自物流、科技、供應鏈管理等不同領域，曾服務過本地及跨國物流企業。我們了解倉庫日常運作的每一個細節，明白司機在路上會遇到的各種情況，更清楚老闆們最關心的成本和效率問題。",
    values: {
      title: "我們的價值觀",
      local: {
        title: "本地化",
        desc: "系統完全針對香港市場設計，支援繁體中文、本地地址格式、香港常用快遞商整合",
      },
      practical: {
        title: "實用至上",
        desc: "功能設計以實際需求為本，唔會有多餘複雜嘅功能，上手快、用得順",
      },
      support: {
        title: "貼心支援",
        desc: "本地團隊提供廣東話/普通話支援，有問題即時回應，唔使等海外客服",
      },
      flexible: {
        title: "靈活彈性",
        desc: "按需收費，唔使一次過大額投資，業務增長時系統可以一齊擴展",
      },
    },
  },
  industries: {
    title: "行業應用方案",
    subtitle: "不同行業，同樣專業的物流解決方案",
    ecommerce: {
      title: "電商零售",
      desc: "支援多平台訂單整合（HKTVmall、Shopify、自家網店），自動同步庫存，快速處理大量訂單。旺季高峰期都能應付自如，確保準時出貨。",
      features: ["多平台訂單整合", "自動庫存同步", "批量出貨處理", "退貨管理"],
    },
    food: {
      title: "食品餐飲",
      desc: "針對生鮮、凍肉、餐飲原材料等有時效性的貨品，提供溫控追蹤、先進先出管理、保質期提醒等功能，確保食品安全合規。",
      features: ["保質期管理", "先進先出 (FIFO)", "溫控記錄", "批次追溯"],
    },
    manufacturing: {
      title: "製造業",
      desc: "原材料入庫、半成品管理、成品出貨一條龍管理。支援 BOM 物料清單、生產領料、品質檢驗等功能，與生產流程無縫對接。",
      features: ["原材料管理", "BOM 物料清單", "生產領料", "品質檢驗"],
    },
    thirdParty: {
      title: "第三方物流 (3PL)",
      desc: "多客戶、多倉庫管理，獨立計費、獨立報表。支援增值服務管理（貼標、分裝、組合包裝），幫助 3PL 企業提升服務質素和盈利能力。",
      features: ["多客戶管理", "獨立計費報表", "增值服務管理", "客戶入口"],
    },
    medical: {
      title: "醫藥物流",
      desc: "符合 GDP 規範的倉儲管理，支援藥品批號追蹤、有效期管理、溫濕度監控、召回管理等功能，確保藥品安全和合規。",
      features: ["批號追蹤", "有效期管理", "溫濕度監控", "召回管理"],
    },
    furniture: {
      title: "傢俬電器",
      desc: "大件貨品的特殊處理需求，支援預約送貨時段、上樓服務安排、安裝服務追蹤、舊機回收等功能，提升客戶體驗。",
      features: ["預約送貨時段", "上樓服務", "安裝追蹤", "舊機回收"],
    },
  },
  faq: {
    title: "常見問題",
    subtitle: "解答您最關心的問題",
    questions: {
      q1: {
        question: "系統如何導入？需要多長時間？",
        answer:
          "我們提供全程導入支援服務。一般情況下，基礎版系統可在 1-2 週內完成部署和培訓；如需數據遷移或客製化設定，約需 3-4 週。我們的專業團隊會協助您完成現有數據匯入、員工培訓、系統調試等工作，確保順利過渡。",
      },
      q2: {
        question: "能否與我現有的 ERP/會計系統對接？",
        answer:
          "可以。AUTOCHAIN 提供標準 API 接口，支援與主流 ERP 系統（如 SAP、Oracle、用友、金蝶）、會計軟件（如 Xero、QuickBooks）、電商平台（如 Shopify、WooCommerce）等對接。我們的技術團隊會協助評估對接需求並提供解決方案。",
      },
      q3: {
        question: "收費模式是怎樣的？",
        answer:
          "我們採用 SaaS 訂閱模式，按月或按年收費，無需大額前期投資。費用根據功能模組和使用量（如用戶數、訂單量、倉庫數）計算。我們提供免費試用期，讓您先體驗再決定。詳細報價請聯絡我們的銷售團隊。",
      },
      q4: {
        question: "數據安全如何保障？",
        answer:
          "我們採用銀行級加密技術（SSL/TLS）保護數據傳輸，所有數據存儲於符合國際標準的雲端數據中心，定期進行安全審計和備份。系統支援多重身份驗證、權限管理、操作日誌等安全功能，確保您的商業數據安全。",
      },
      q5: {
        question: "系統支援哪些語言？",
        answer:
          "系統介面支援繁體中文、簡體中文和英文，可隨時切換。報表和標籤打印也支援多語言輸出，方便處理跨境業務。",
      },
      q6: {
        question: "有沒有手機 App？",
        answer:
          "有。我們提供司機專用 App（支援 iOS 和 Android），用於接收任務、導航、簽收拍照等。倉庫員工可使用手機或平板進行掃碼作業。管理層可透過手機瀏覽器隨時查看報表和系統狀態。",
      },
      q7: {
        question: "如果遇到問題，如何獲得支援？",
        answer:
          "我們提供多種支援渠道：電郵支援（所有方案）、WhatsApp 即時通訊、電話支援（專業版及以上）、專屬客戶經理（企業版）。本地團隊提供廣東話/普通話支援，一般查詢在 24 小時內回覆，緊急問題即時處理。",
      },
      q8: {
        question: "可以先試用再決定嗎？",
        answer:
          "當然可以。我們提供 14 天免費試用，無需綁定信用卡。試用期間可體驗全部功能，我們的團隊會協助您設定系統和導入測試數據。試用結束後，您可以選擇訂閱或取消，絕無壓力。",
      },
    },
  },
  wmsFeatures: {
    title: "WMS 核心功能模組",
    subtitle: "全面覆蓋倉庫管理每個環節",
    inbound: {
      title: "入庫管理",
      desc: "支援採購入庫、退貨入庫、調撥入庫等多種入庫類型。掃碼驗收、自動分配儲位、批次管理一應俱全，確保入庫準確高效。",
    },
    inventory: {
      title: "庫存管理",
      desc: "實時庫存查詢、多維度庫存報表、庫存預警、盤點管理。支援批次管理、序列號管理、保質期管理，滿足不同行業需求。",
    },
    picking: {
      title: "揀貨包裝",
      desc: "智能揀貨路徑規劃、波次揀貨、邊揀邊播。支援多種包裝規範、自動計算包材、打印裝箱單和快遞單。",
    },
    outbound: {
      title: "出庫管理",
      desc: "訂單自動分配、批量出庫處理、出庫覆核。支援多種出庫策略（FIFO、FEFO、指定批次），確保出庫準確無誤。",
    },
    courier: {
      title: "快遞整合",
      desc: "一鍵對接順豐、嘉里、DHL 等主流快遞商，自動生成運單、打印快遞標籤、追蹤物流狀態，大幅提升出貨效率。",
    },
    reporting: {
      title: "報表分析",
      desc: "庫存周轉率、揀貨效率、出入庫統計等多維度報表。數據可視化大屏，幫助管理層即時掌握倉庫運營狀況。",
    },
  },
  tmsFeatures: {
    title: "TMS 核心功能模組",
    subtitle: "從接單到送達，全程智能管理",
    routing: {
      title: "智能排線",
      desc: "AI 演算法自動規劃最優路線，考慮交通狀況、送貨時段、車輛載重等因素。三種排線模式任選，大幅節省排線時間和運輸成本。",
    },
    tracking: {
      title: "實時追蹤",
      desc: "GPS 定位即時顯示車輛位置，送貨狀態實時更新。客戶可收到送貨通知和預計到達時間，提升服務體驗。",
    },
    driver: {
      title: "司機管理",
      desc: "司機資料、駕照、排班一站管理。績效追蹤、薪酬計算自動化，支援按里程、按單量、按時薪等多種計算方式。",
    },
    vehicle: {
      title: "車隊管理",
      desc: "車輛資料、維修記錄、油耗監控完整記錄。保養提醒、年檢提醒自動通知，確保車隊安全運營。",
    },
    pod: {
      title: "電子簽收",
      desc: "司機 App 拍照簽收，客戶電子簽名確認。所有 POD 記錄自動歸檔，有據可查，減少送貨爭議。",
    },
    analytics: {
      title: "數據分析",
      desc: "準時率、送貨成本、司機績效等關鍵指標一目了然。數據驅動決策，持續優化運輸效率。",
    },
  },
  tplsp: {
    title: "第三方物流服務供應商資助先導計劃",
    subtitle:
      "政府資助 3PL Funding | Third Party Logistics Service Providers Subsidy Scheme",
    description:
      "為維持香港物流業界的競爭力，香港特別行政區政府已於 2020 年 10 月 12 日成立「第三方物流服務供應商資助先導計劃」，鼓勵物流業透過科技應用提升效率和生產力",
    seo: {
      title:
        "第三方物流資助計劃 TPLSP | 政府資助 3PL Funding 顧問及供應商 (Vendor)",
      description:
        "AUTOCHAIN 是 TPLSP (3PL Funding) 第三方物流資助計劃認可系統供應商。提供合資格 WMS 及 TMS 系統，協助申請 200 萬政府資助，包括物流科技及 ESG 項目。",
      keywords:
        "第三方物流資助計劃, TPLSP, 3PL Funding, 政府資助, 物流資助, TPLSP 顧問, TPLSP Vendor, 香港政府資助, 物流科技, WMS, TMS, 300萬資助",
    },
    updates: {
      title: "最新優化措施（2024年2月1日起）",
      subsidy_increase:
        "提高資助上限：每間申請企業的累計資助額上限由一百萬元增至二百萬元",
      scope_expansion:
        "擴大資助範圍：涵蓋環境、社會及管治(ESG)科技方案和相關的應用服務，包括顧問服務",
      training_support:
        "新增培訓資助：資助範圍擴展至包括與應用科技相關的項目培訓",
    },
    overview: {
      title: "計劃簡介",
      duration: "項目年期",
      duration_value: "0-24個月",
      subsidy_ratio: "資助比例",
      subsidy_ratio_value: "50%項目總核準開支",
      max_amount: "累積資助額",
      max_amount_value: "HK$2,000,000最高上限",
      max_projects: "項目數量",
      max_projects_value: "4個最多可獲資助",
    },
    eligibility: {
      title: "申請資格",
      description:
        "按照《商業登記條例》(第310章)在香港登記的非上市企業，並符合以下條件，均可遞交申請：",
      condition1: "在提供第三方物流服務，如供應鏈及分銷管理等增值服務",
      condition2: "業務須與進口或出口物流服務有關",
      condition3: "在項目進行期間必須維持符合申請資格的條件",
    },
    funding: {
      title: "撥款方式",
      first_payment: "首期撥款",
      first_payment_desc:
        "成功申請的企業可於簽訂資助協議後獲取核準撥款總數的50%作為項目首期撥款",
      final_payment: "終期撥款",
      final_payment_desc: "終期撥款會在以下條件達成後發放：",
      final_condition1: "項目完成",
      final_condition2: "終期報告獲管理委員會及秘書處接納",
    },
    scope: {
      title: "主要資助範圍",
      description:
        "申請項目須透過應用科技/或資訊系統，提升物流增值服務的生產力及效率",
      subtitle: "有關物流科技應用例子：",
      automation: "自動化設備、機械設備及人工智能科技應用",
      edi: "電子資料交換與互聯系統 (EDI)",
      tms: "交通管理系統 (TMS)",
      erp: "企業資源管理系統 (ERP)",
      analytics: "物流及供應鏈分析系統",
      infrastructure: "科技網絡基建",
      wms: "倉庫/貨物分流中心管理系統 (WMS)",
      rtls: "物流實時定位系統 (RTLS)",
      iot: "物聯網 (IoT) 及 RFID 技術應用",
      security: "管制空運貨物安檢設施 (RACSFs) X光檢查設備",
    },
    process: {
      title: "申請流程",
      step1: "準備文件",
      step1_desc: "準備商業登記證及相關業務證明文件",
      step2: "提交申請",
      step2_desc: "填寫申請表格並提交所需文件",
      step3: "審批評估",
      step3_desc: "管理委員會審核申請並進行評估",
      step4: "獲批撥款",
      step4_desc: "簽訂協議後獲得首期撥款",
    },
    diy: {
      title: "不需要俾顧問費！你完全可以自己申請！",
      subtitle: "Autochain 免費提供指導助你可以自己申請資助",
      step1: {
        title: "Step 1: HKPC申請帳號",
        desc: "1）先透過HKPC申請資格檢查確定申請資格\n2）透過申請系統建立帳號",
        link: "https://bee.hkpc.org/tc/funding-schemes/tplsp/",
      },
      step2: {
        title: "Step 2: 填寫申請表(項目計劃書)",
        desc: "項目計劃書是審批的核心。需清晰闡述：現有物流運作痛點，項目如何解決問題（採用何種第三方物流服務及技術), 預期效益（如成本降低、效率提升、錯誤減少等量化指標）及項目實施時間表。可以聯絡我們獲取計劃書的指南及範本。",
      },
      step3: {
        title: "Step 3: RFQ以獲報價單及提交申請",
        desc: "獲取足夠報價單也是申請過程中其中一個大關卡，一傷清晰的RFQ絕對令你省卻很多來來回回的溝通時間。",
      },
    },
    cta: {
      title: "準備申請第三方物流資助計劃？",
      description:
        "若需要項目計劃書template 及 RFQ template，請聯絡我們的團隊獲取！",
      whatsapp: "WhatsApp 諮詢",
      phone: "致電查詢",
      phone_number: "(852) 9425 2903",
      email: "sales@autochain.com.hk",
    },
  },
  privacy: {
    title: "隱私政策",
    lastUpdated: "最後更新日期：2024年2月",
    intro:
      "AUTOCHAIN TECHNOLOGY（以下簡稱「我們」）重視您的隱私權。本隱私政策說明我們如何收集、使用、儲存及保護您在使用我們的 WMS（倉庫管理系統）應用程式時所提供的個人資料。",
    section1: {
      title: "1. 我們收集的資料",
      content: "在您使用 WMS 應用程式時，我們可能會收集以下類型的資料：",
      item1: "帳戶資料：包括您的姓名、電子郵件地址、電話號碼及公司資訊",
      item2: "倉庫運作資料：包括庫存記錄、訂單資料、貨物資訊及相關業務數據",
      item3: "裝置資料：包括裝置型號、作業系統版本、唯一裝置識別碼",
      item4:
        "使用資料：包括您如何使用應用程式的資訊，例如功能使用記錄及操作日誌",
      item5:
        "位置資料：在您授權的情況下，我們可能收集裝置的位置資訊以提供相關服務",
    },
    section2: {
      title: "2. 資料使用目的",
      content: "我們收集的資料將用於以下目的：",
      item1: "提供及維護 WMS 應用程式的核心功能",
      item2: "改善及優化應用程式的效能與用戶體驗",
      item3: "提供客戶支援及技術協助",
      item4: "進行系統安全監控及防止詐欺行為",
    },
    section3: {
      title: "3. 資料分享與披露",
      content:
        "我們不會出售、出租或交易您的個人資料給第三方。我們僅在以下情況下分享您的資料：獲得您的明確同意、遵守法律要求或法院命令、保護我們的合法權益及用戶安全。",
    },
    section4: {
      title: "4. 資料安全",
      content: "我們採取適當的技術及組織措施來保護您的個人資料，包括：",
      item1: "使用加密技術保護資料傳輸",
      item2: "實施存取控制及身份驗證機制",
      item3: "定期進行安全審計及系統更新",
    },
    section5: {
      title: "5. 資料保留",
      content:
        "我們僅在必要期間內保留您的個人資料，以達成本政策所述的目的。當資料不再需要時，我們將安全地刪除或匿名化處理。",
    },
    section6: {
      title: "6. 您的權利",
      content:
        "您有權查閱、更正或刪除您的個人資料。如需行使這些權利，請透過以下聯絡方式與我們聯繫。",
    },
    section7: {
      title: "7. 聯絡我們",
      content: "如對本隱私政策有任何疑問或需要協助，請聯絡我們：",
    },
    contact: {
      company: "公司名稱：",
      email: "電子郵件：",
      phone: "電話：",
    },
  },
  deleteAccount: {
    title: "刪除帳號申請",
    warningTitle: "重要提示",
    warningMessage:
      "刪除帳號後，您的所有資料將被永久刪除，包括庫存記錄、訂單歷史及所有相關數據。此操作無法撤銷。",
    email: "註冊電郵地址",
    emailPlaceholder: "請輸入您的註冊電郵",
    phone: "註冊電話號碼",
    phonePlaceholder: "請輸入您的註冊電話",
    reason: "刪除原因（選填）",
    reasonSelect: "請選擇原因",
    reason1: "不再使用此服務",
    reason2: "隱私考慮",
    reason3: "已轉用其他服務",
    reason4: "其他原因",
    confirmLabel:
      "我確認要刪除我的帳號，並了解此操作無法撤銷，所有資料將被永久刪除。",
    submitButton: "提交刪除申請",
    processingTime: "我們將在 7 個工作天內處理您的申請，並以電郵通知您。",
    successTitle: "申請已提交",
    successMessage:
      "我們已收到您的帳號刪除申請。我們將在 7 個工作天內處理，並以電郵通知您處理結果。",
    submitError: "提交失敗，請稍後再試或直接聯絡我們。",
  },
};
